module.exports = __webpack_public_path__ + "imgs/wheresweed-home-hero.1c3cb34ef28c5e54696440a5becbaf67.jpg";